module.exports = __webpack_public_path__ + "static/img/img04@2x.62a8a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/img04@2x.png
// module id = KR9h
// module chunks = 174